import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';

export interface SendConfigChangeItem {
  label: string;
  from?: string;
  to: string;
  reset?: boolean;
}

export interface SendConfigChange {
  address: number;
  typeLabel: string;
  kind: 'new' | 'changed' | 'removed';
  items: SendConfigChangeItem[];
}

export interface SendConfigModalData {
  changes: SendConfigChange[];
  errors: string[];
}

@Component({
  selector: 'app-send-config-modal',
  templateUrl: './send-config-modal.component.html',
  styleUrls: ['./send-config-modal.component.scss'],
})
export class SendConfigModalComponent {
  public changes: SendConfigChange[];
  public errors: string[];

  constructor(
    private dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) data: SendConfigModalData
  ) {
    this.changes = data.changes;
    this.errors = data.errors;
  }

  public close() {
    this.dialogRef.close(false);
  }

  public send() {
    this.dialogRef.close(true);
  }
}
